import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "./../../axios";
import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";
import ReportTableComponent from "./ReportTableComponent/ReportTableComponent";
import * as XLSX from "xlsx";
import SendEmailDialog from "../NotifyShortage/SendEmailDialog";
import DatePicker from "react-datepicker";
import { ArrowDownWideNarrow, Info, Search } from "lucide-react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

function Report({ leftSidebarSize }) {
  const schoolId = JSON.parse(localStorage.getItem("schoolId"));
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const academicYearSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );
  const [selectedAcademicSessionId, setSelectedAcademicSessionId] =
    useState(null);
  const [selectedTimetableId, setSelectedTimetableId] = useState(null);
  const [classId, setClassId] = useState(null);
  const [sectionId, setSectionId] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [students, setStudents] = useState([]);
  const [isModified, setIsModified] = useState(false);
  const [enableSubmitBtn, setEnableSubmitBtn] = useState(false);
  const [academicSessionData, setAcademicSessionData] = useState([]);
  const [schoolSessionTimeTable, setSchoolSessionTimeTable] = useState([]);
  const [academicYearId, setAcademicYearId] = useState(null);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [totalStudentCounts, settotalStudentCounts] = useState(false);
  const [emailDialog, setEmailDialog] = useState(false);

  const [isGettingData, setIsGettingData] = useState(false);
  const [dropdownLists, setDropdownLists] = useState({
    standards: null,
    sections: null,
  });

  const [schoolName, setSchoolName] = useState("");

  const CTRole_Information = JSON.parse(
    localStorage.getItem("role_as_class_teacher"),
  );
  const CoRole_Information = JSON.parse(
    localStorage.getItem("role_as_co_ordinator"),
  );

  const userInfo = JSON.parse(localStorage.getItem("UserInformation"));

  useEffect(() => {
    if (userInfo) {
      setSchoolName(userInfo?.school.name);
    }
  }, []);
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  // useEffect(() => {
  //   if (CTRole_Information && CTRole_Information.length > 0) {
  //     CTRole_Information?.forEach((obj) => {
  //       if (obj.is_class_teacher === true) {
  //         if (!standardList.some((i) => i.id === obj.standard_id.id)) {
  //           standardList.push(obj.standard_id);
  //         }
  //         if (!sectionList.some((i) => i.id === obj.section_id.id)) {
  //           sectionList.push(obj.section_id);
  //         }
  //       }
  //     });
  //   }

  //   if (CoRole_Information && CoRole_Information.length > 0) {
  //     CoRole_Information?.forEach((obj) => {
  //       if (obj?.is_class_co_ordinator === true) {
  //         if (!standardList.some((i) => i.id === obj.standard_id.id)) {
  //           standardList.push(obj.standard_id);
  //         }
  //         if (!sectionList.some((i) => i.id === obj.section_id.id)) {
  //           sectionList.push(obj.section_id);
  //         }
  //       }
  //     });
  //   }
  //   // if (general_role && general_role.length > 0) {
  //   //     general_role?.forEach((obj) => {
  //   //         if (!standardList.some((i) => i.id === obj.standard_id.id)) {
  //   //             standardList.push(obj.standard_id);
  //   //         }
  //   //         if (!sectionList.some((i) => i.id === obj.section_id.id)) {
  //   //             sectionList.push(obj.section_id);
  //   //         }
  //   //     });
  //   // }
  //   standardList.length > 0 &&
  //     setDropdownLists((prev) => ({ ...prev, standards: standardList }));

  //   sectionList.length > 0 &&
  //     setDropdownLists((prev) => ({ ...prev, sections: sectionList }));

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  let sectionArr = [];
  let standardArr = [];
  const dropDownHelper = () => {
    function addUniqueObjectToArraystand(obj) {
      if (
        !standardArr.some(
          (item) => JSON.stringify(item) === JSON.stringify(obj),
        )
      ) {
        standardArr.push(obj);
      }
    }
    CTRole_Information?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    CoRole_Information?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
  };

  dropDownHelper();

  const handleDropDownSec = () => {
    function addUniqueObjectToArraysect(obj) {
      if (
        !sectionArr.some((item) => JSON.stringify(item) === JSON.stringify(obj))
      ) {
        sectionArr.push(obj);
      }
    }
    CTRole_Information?.map((obj) => {
      if (obj?.standard_id?.id === classId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    CoRole_Information?.map((obj) => {
      if (obj?.standard_id?.id === classId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
  };
  handleDropDownSec();

  // useEffect(() => {
  //     const handleAcademicYear = async () => {
  //         try {
  //             const getRes = await axios.get(`/api/v1/school/academicYear/get/school/${schoolId}`)
  //             if (getRes) {
  //                 setAcademicYearId(getRes?.data?.data?.id);
  //             }
  //         } catch (error) {
  //             toast.error(error.response.data.message)
  //         }

  //     };
  //     handleAcademicYear()
  //     handleAcademicYearData()
  //     handleSchoolTimeTableData()
  // }, [schoolId, academicYearId])

  // const handleAcademicYearChange = (value) => {
  //     setSelectedAcademicSessionId(value)
  //     setSelectedTimetableId(null);
  //     setIsModified(false);
  //     setShowTable(false);
  // }
  // const handleTimetableChange = (value) => {
  //     setSelectedTimetableId(value);
  //     setIsModified(false);
  //     setShowTable(false);
  // };

  const handleClassChange = (value) => {
    setClassId(value);
    setIsModified(false);
    setShowTable(false);
    setSectionId(null);
  };
  const handleSectionChange = (value) => {
    setSectionId(value);
    setIsModified(false);
    setShowTable(false);
  };
  useEffect(() => {
    if (!classId || !sectionId || !selectedStartDate || !selectedEndDate) {
      setEnableSubmitBtn(true);
    } else {
      setEnableSubmitBtn(false);
    }
  }, [classId, sectionId, selectedStartDate, selectedEndDate]);

  const getDataofTable = async () => {
    if (!selectedStartDate || !selectedEndDate) {
      return toast.error("Both start date and end date are required.");
    }

    let body = {
      academicSessionId: academicYearSessionId,
      standardId: classId,
      sectionId: sectionId,
      timetableSessionId: timeTableSessionId,
      startDate: formatDate(selectedStartDate),
      endDate: formatDate(selectedEndDate),
      criteria: "0",
    };

    try {
      setIsGettingData(true); // ✅ START LOADER
      const res = await axios.post(`/api/v1/classLevelDetails`, body);
      setStudents(res?.data?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to load data");
    } finally {
      setIsGettingData(false); // ✅ STOP LOADER
    }
  };

  const handleTableUi = () => {
    setShowTable(true);
    getDataofTable();
  };

  // const dateHelper = (a) => {
  //     const inputDate = new Date(a);
  //     const month = inputDate.getMonth() + 1;
  //     const day = inputDate.getDate();
  //     const year = inputDate.getFullYear();
  //     const formattedDate = `${year}/${month}/${day}`;
  //     return formattedDate;
  // };

  const handleDownloadSubmit = () => {
    if (!students || !students.shortageStudents) {
      toast.error("No data available to download.");
      return;
    }

    const statusMap = {
      Present: "P",
      Absent: "A",
      Leave: "L",
      Delay: "D",
      "Not Taken": "NT",
    };

    const filteredStudents =
      selectedStudents?.length > 0
        ? students.shortageStudents.filter((student) =>
            selectedStudents.includes(student.student._id),
          )
        : students.shortageStudents;

    if (filteredStudents.length === 0) {
      toast.error("No students found.");
      return;
    }

    // 🔥 SORT DATES IN ASCENDING ORDER
    const sortedAttendancePerDay = [...students.classAttendancePerDay].sort(
      (a, b) => new Date(a.date) - new Date(b.date),
    );

    const formattedData = filteredStudents.map((student, index) => {
      const dailyAttendance = sortedAttendancePerDay.reduce(
        (acc, attendance) => {
          const studentAttendance = students?.studentsAttendancePerDay
            ?.find((att) => att.date === attendance.date)
            ?.students.find((stu) => stu.studentId === student.student._id);

          acc[`${attendance.date} [${attendance.day}]`] = studentAttendance
            ? statusMap[studentAttendance.status] || "NT"
            : "NT";

          return acc;
        },
        {},
      );

      return {
        "Sr. No": index + 1,
        "Roll Code": student.student.code || "N/A",
        "Student Name": student.student.name || "N/A",
        "Attendance %":
          `${student.attendancePercentage}% [${student.presentDays} / ${student.totalDays}]` ||
          "N/A",
        ...dailyAttendance,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance Report");

    XLSX.writeFile(workbook, "Attendance_Report.xlsx");
    setSelectedStudents([]);
  };

  const handleSendEmail = async (emailBody) => {
    const selectedEmails = students?.shortageStudents
      ?.filter((student) => selectedStudents.includes(student?.student?._id))
      .map((student) => ({
        name: student?.student?.name,
        email: student?.student?.email,
      }));

    const payload = {
      shortageStudent: selectedEmails,
      emailSubject: "Attendance Report",
      emailBody: emailBody,
    };

    setIsGettingData(true);

    try {
      const res = await axios.post(`/api/v1/shortageMail`, payload);

      if (res) {
        toast.success(res?.data?.message);
        setSelectedStudents([]);
        setIsGettingData(false);
      }
    } catch (error) {
      console.error("Error sending email:", error);
      toast.error("Error sending email");
      setIsGettingData(false);
    } finally {
      setIsGettingData(false);
    }
  };

  return (
    <div
      className={`card ${leftSidebarSize === 70 ? "expand" : "collapasess"} `}
    >
      <h2 className="card-header">Attendance Report</h2>
      <div className="row">
        <div
          className="form-container col-12 mb-4"
          style={{ gap: "15px", position: "relative" }}
        >
          <FormControl size="small" style={{ width: 180 }}>
            <InputLabel>Class*</InputLabel>
            <Select
              label="Class*"
              value={classId || ""}
              onChange={(e) => handleClassChange(e.target.value)}
            >
              <MenuItem value="null">Select Class</MenuItem>
              {standardArr?.length > 0 &&
                [...standardArr]
                  .sort((a, b) => {
                    const aNum = Number(a.name);
                    const bNum = Number(b.name);

                    const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                    if (bothNumeric) {
                      return aNum - bNum; // numeric sort
                    }

                    return a.name.localeCompare(b.name); // alphabetical sort
                  })
                  .map((standard, index) => (
                    <MenuItem
                      key={index}
                      value={standard?.id}
                      name={standard?.name}
                    >
                      {standard?.name}
                    </MenuItem>
                  ))}
            </Select>
          </FormControl>
          <FormControl size="small" style={{ width: 180 }}>
            <InputLabel>Section*</InputLabel>
            <Select
              label="Section*"
              value={sectionId || ""}
              onChange={(e) => handleSectionChange(e.target.value)}
            >
              <MenuItem value="null">Select Section</MenuItem>
              {sectionArr
                ?.slice()
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((section) => (
                  <MenuItem key={section.id} value={section.id}>
                    {section.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <DatePicker
            selected={selectedStartDate}
            onChange={(date) => {
              setSelectedStartDate(date);
              setShowTable(false);
            }}
            dateFormat="dd/MM/yyyy"
            placeholderText="Choose Start date"
            className="form-control mw-100"
            popperProps={{
              modifiers: [
                {
                  name: "zIndex",
                  enabled: true,
                  phase: "beforeWrite",
                  fn({ state }) {
                    state.styles.popper.zIndex = 9999999;
                  },
                },
              ],
            }}
          />

          <DatePicker
            selected={selectedEndDate}
            onChange={(date) => {
              setSelectedEndDate(date);
              setShowTable(false);
            }}
            dateFormat="dd/MM/yyyy"
            placeholderText="Choose End date"
            className="form-control mw-100"
            popperProps={{
              modifiers: [
                {
                  name: "zIndex",
                  enabled: true,
                  phase: "beforeWrite",
                  fn({ state }) {
                    state.styles.popper.zIndex = 9999999;
                  },
                },
              ],
            }}
          />
          <div className="col-2 ">
            <button
              className="list-button"
              disabled={
                (showTable && true) ||
                !classId ||
                !sectionId ||
                !selectedStartDate ||
                !selectedEndDate
              }
              onClick={() => {
                handleTableUi();
              }}
            >
              Generate Report
            </button>
          </div>
        </div>
      </div>
      {showTable && (
        <ReportTableComponent
          students={students}
          setSelectedStudents={setSelectedStudents}
          selectedStudents={selectedStudents}
          handleDownloadSubmit={handleDownloadSubmit}
          isGettingData={isGettingData}
          setEmailDialog={setEmailDialog}
        />
      )}

      {emailDialog && (
        <SendEmailDialog
          isOpen={emailDialog}
          onClose={() => setEmailDialog(false)}
          onSend={handleSendEmail}
          startDate={selectedStartDate}
          endDate={selectedEndDate}
          schoolName={schoolName}
          type="report"
        />
      )}
    </div>
  );
}

export default Report;
